import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { toast } from 'react-toastify';
import EyeOutlineIcon from 'mdi-react/EyeOutlineIcon';
import EyeOffOutlineIcon from 'mdi-react/EyeOffOutlineIcon';
import ContentCopyIcon from 'mdi-react/ContentCopyIcon';
import { partial } from '../../../util/translation/translation';
import SquareIconButton from './SquareIconButton';

// Only the last characters, so the key can be told apart without showing it
const maskKey = (key = '') => `••••••••${`${key}`.slice(-4)}`;

/**
 * An API key in a table cell: masked, with buttons to show it and to copy
 * it. Styles: .api-key in form-card.scss.
 */
const ApiKeyValue = ({ apiKey, id }) => {
  const s = partial('shared');
  const [shown, setShown] = useState(false);

  const copyKey = async () => {
    try {
      await navigator.clipboard.writeText(apiKey);
      toast.success(s('keyCopied'));
    } catch {
      toast.error(s('somethingWentWrong'));
    }
  };

  return (
    <div className="api-key">
      <code className="api-key__value">{shown ? apiKey : maskKey(apiKey)}</code>
      <SquareIconButton
        icon={shown ? <EyeOffOutlineIcon /> : <EyeOutlineIcon />}
        title={shown ? s('hide') : s('show')}
        id={`show-key-${id}`}
        active={shown}
        onClick={() => setShown((value) => !value)}
      />
      <SquareIconButton
        icon={<ContentCopyIcon />}
        title={s('copyKey')}
        id={`copy-key-${id}`}
        onClick={copyKey}
      />
    </div>
  );
};

ApiKeyValue.propTypes = {
  apiKey: PropTypes.string,
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};

ApiKeyValue.defaultProps = {
  apiKey: '',
};

export default ApiKeyValue;
